import { createClient } from '@supabase/supabase-js';
const supabaseRequest = createClient(
  process.env.REACT_APP_BASE_SUPABASE_API ?? '',
  process.env.REACT_APP_SUPABASE_APIKEY ?? ''
);
export default supabaseRequest;
